const e = {
  "error-title": "styles-module__error-title___pnScw",
  "error-subtitle": "styles-module__error-subtitle___3Ugvb"
};
export {
  e as default
};
